class HeroSliderElement extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll('.hero-slider__slide');
    this.dots = this.querySelectorAll('.hero-slider__dot');
    this.prevBtn = this.querySelector('.hero-slider__arrow--prev');
    this.nextBtn = this.querySelector('.hero-slider__arrow--next');
    
    this.currentIndex = 0;
    this.totalSlides = this.slides.length;
    this.autoplayInterval = null;
    this.isTransitioning = false;

    // Settings
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed);

    if (this.totalSlides > 0) this.init();
  }

  init() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prevSlide());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.nextSlide());
    
    this.dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        this.goToSlide(parseInt(e.currentTarget.dataset.dotIndex));
      });
    });

    if (this.autoplay) {
      this.startAutoplay();
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }

    this.updateControls();

    // Touch Support
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.addEventListener('touchstart', (e) => { this.touchStartX = e.changedTouches[0].screenX; }, false);
    this.addEventListener('touchend', (e) => {
      this.touchEndX = e.changedTouches[0].screenX;
      if (this.touchEndX < this.touchStartX - 50) this.nextSlide();
      if (this.touchEndX > this.touchStartX + 50) this.prevSlide();
    }, false);
  }

  goToSlide(index) {
    if (this.isTransitioning || index === this.currentIndex) return;
    this.isTransitioning = true;

    this.slides[this.currentIndex].classList.remove('is-active');
    this.currentIndex = (index + this.totalSlides) % this.totalSlides;
    this.slides[this.currentIndex].classList.add('is-active');

    this.updateControls();

    setTimeout(() => {
      this.isTransitioning = false;
    }, 800);
  }

  nextSlide() { this.goToSlide(this.currentIndex + 1); }
  prevSlide() { this.goToSlide(this.currentIndex - 1); }

  updateControls() {
    this.dots.forEach((dot, index) => {
      const isActive = index === this.currentIndex;
      dot.classList.toggle('is-active', isActive);
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => this.nextSlide(), this.speed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) clearInterval(this.autoplayInterval);
  }
}

if (!customElements.get('hero-slider')) {
  customElements.define('hero-slider', HeroSliderElement);
}